import { render, staticRenderFns } from "./HistoriesStorageOverview.vue?vue&type=template&id=32418b04"
import script from "./HistoriesStorageOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoriesStorageOverview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports